import About from "./About";
import Coding from "./Coding";
import Contact from "./Contact";

export const pages = { About: About, Coding: Coding, Contact: Contact }